import { render, staticRenderFns } from "./notification-event-table.vue?vue&type=template&id=48d69475&scoped=true"
import script from "./notification-event-table.vue?vue&type=script&lang=js"
export * from "./notification-event-table.vue?vue&type=script&lang=js"
import style0 from "./notification-event-table.vue?vue&type=style&index=0&id=48d69475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d69475",
  null
  
)

export default component.exports